import { PropsWithChildren } from 'react'
import { StyledSidebarDividerText, StyledDivider } from '../../styles/SidebarStyles'

type SidebarDividerProps = {
  open: boolean
  withoutDivider?: boolean
}

const SidebarDivider = ({ open, withoutDivider, children }: PropsWithChildren<SidebarDividerProps>) => {
  return (
    <>
      {open ? (
        <StyledSidebarDividerText
          variant="body2"
          fontSize={12}
          sx={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {children}
        </StyledSidebarDividerText>
      ) : withoutDivider ? (
        <></>
      ) : (
        <StyledDivider />
      )}
    </>
  )
}

export default SidebarDivider
